export default function AdminNameTitle({ adminName, role }) {
    return (
        <h6 className="text-end m-0 c-darkOrange">{adminName}
            <span className="text-end mx-2 text-white bg-light-beige-10 p-1 rounded-1">{role}</span>
        </h6>
    );
}